import { TweenLite } from '../../../../node_modules/gsap';
import { fetchFalckdkApi } from '../utils/fetch.js';

export async function addtobasket(productcode, quantity, successCallback, errorCallback) {
    try {
        const response = fetchFalckdkApi('/api/Basket/Add', {
            method: 'POST',
            body: { code: productcode, quantity },
        });

        const data = await response.json();

        successCallback(data);
    } catch (error) {
        console.error('Error adding to basket:', error);
        errorCallback(error);
    }
}

export async function addtoPo(productcode, quantity, successCallback, errorCallback) {
    try {
        const response = fetchFalckdkApi('/api/Basket/AddAndReplacePurchaseOrder', {
            method: 'POST',
            body: { code: productcode, quantity },
        });

        const data = await response.json();

        successCallback(data);
    } catch (error) {
        console.error('Error adding to purchase order:', error);
        errorCallback(error);
    }
}

export async function removefrombasket(lineitemid, successCallback, errorCallback) {
    try {
        const response = await fetchFalckdkApi('/api/Basket/Remove', {
            method: 'POST',
            body: { lineitemid },
        });

        const data = await response.json();

        successCallback(data);
    } catch (error) {
        console.error('Error removing from basket:', error);
        errorCallback(error);
    }
}

export async function updatebasketpreview(resultCount, getHeaderBasketUrl) {
    const countUpdate = $('#basket-preview-countupdate');
    const countUpdateMobile = $('#basket-preview-mobile-countupdate');
    const basketOrderButton = $('#basketPreviewOrderButton');
    const basketIcon = $('.js-basket-icon');

    countUpdate.html(resultCount);
    countUpdateMobile.html(resultCount);

    if (resultCount > 0) {
        countUpdate.removeAttr('style');
        countUpdateMobile.removeAttr('style');
        basketOrderButton.removeClass('disabled');
    } else {
        basketIcon.removeClass('active');
        countUpdate.attr('style', 'display: none;');
        countUpdateMobile.attr('style', 'display: none;');
        basketOrderButton.addClass('disabled');
    }

    try {
        const response = await fetchFalckdkApi(getHeaderBasketUrl, {
            method: 'GET',
            headers: { 'Content-Type': 'text/xml' },
        });

        const data = await response.text();

        const $basketIcon = $('.js-basket-icon');

        $('#basket-preview-ajaxupdate').html(data);

        if ($basketIcon.hasClass('active') && resultCount > 0) {
            // Reopen basket when it was open before the update
            const $basketPreview = $('#js-basket-preview');

            TweenLite.set($basketPreview, { height: 'auto' });
        }

        if ($(document).find('.shopping-cart-page').length > 0) {
            window.location.reload();
        }
    } catch (error) {
        console.error('Error updating basket preview:', error);
    }
}
